import React from 'react';
import { useContext } from 'react';
import SimpleContext from './../context/SimpleContext';
import CustomerAct from './CustomerAct';
import Date from './../Date/Date';


const CustomerActs = () => {

    const context = useContext(SimpleContext);

    return (
        <div className="productsmain">    
            <div className="otherPagesHeader">
                <div className="barbuttonn">
                    <img src="images/Api.jpg" className="apiLogoHeaders" alt=""/>
                </div>
                <div className="headersNames">
                    <p style={{margin:"0"}}>مشخصات کاربر</p>
                </div>
                <div className="pt-2">
                    <p style={{marginTop:"3%", fontSize:"13px"}}>
                        <Date/>
                    </p>
                </div>
            </div>
            <div className="brandsdiv p-2 m-2">
                {
                    context.Acts.length?
                    context.Acts.map(act => 
                        <div className="lev3cat" key={act.ID}>
                            <CustomerAct 
                            actsid={act.ID}
                            ActName={act.ActName}
                            ImgUrl={act.ImgUrl}
                            />
                        </div>
                            
                    ):null
                }
            </div>
        </div>    
     );
}
 
export default CustomerActs;